// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","inner":"footer_inner__5+Jd6","separator":"footer_separator__KLSt-"};